import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  OnDestroy,
  OnInit,
  ViewChild,
  DOCUMENT,
  ChangeDetectionStrategy
} from '@angular/core';
import {AppStore} from "../../../../store/app.store";
import {Subscription} from "rxjs";
import {SocialStoreInterface} from "../../../../store/interfaces/socials-store.interface";


@Component({
    selector: 'yrx-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterComponent implements OnInit, OnDestroy, AfterViewInit {
  constructor(
    private appStore: AppStore,
    @Inject(DOCUMENT) private document: Document,
  ) {
  }

  @ViewChild('footer') footer!: ElementRef;

  private subscriptions: Subscription[] = []

  public socials: SocialStoreInterface[] = []

  ngOnInit() {
    this.subscriptions.push(
      this.appStore.socials$.subscribe((socials) => {
        this.socials = socials
      })
    )
  }

  ngAfterViewInit() {
    const footerHeight: number = this.footer.nativeElement.offsetHeight;
    this.appStore.setFooterHeight(footerHeight);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe())
    this.appStore.setFooterHeight(0);
  }

  public scrollTop() {
    (function smoothScroll() {
      const currentScroll = document.documentElement.scrollTop || document.body.scrollTop;
      if (currentScroll > 0) {
        window.requestAnimationFrame(smoothScroll);
        window.scrollTo(0, Math.floor(currentScroll - (currentScroll / 16)));
      }
    })();
  }
  
}
